
import React from 'react'
import { Container, Subscribe, Provider } from 'unstated'

const MODALS = {
  'book-a-tour': true,
  'calendly': true,
  'success': true,
}

class ModalContainer extends Container {
  constructor() {
    super()

    this.state = {}

    if (typeof window !== 'undefined') {
      window.addEventListener('hashchange', this.handleHashChange)
    }
  }

  handleHashChange = () => {
    const { hash } = window.location

    if (hash) {
      const parts = hash.split('#')
      
      if (parts[1]) {
        const id = parts[1].split(':')[0]
        console.log(id)
        this.open(id)
      }
    }
  }

  getReset = () => {
    const newState = {}
    Object.keys(this.state).forEach(key => {
      newState[key]= false
    })
    return newState
  }

  reset = () => {
    document.body.style.overflow = 'auto'
    this.setState({ ...this.getReset() })
  }

  open = (id) => {
    if (!MODALS[id]) {
      return 
    }
    
    document.body.style.overflow = 'hidden'
    this.setState({ ...this.getReset(), [id]: true  })
  }

  close = (id) => {
    document.body.style.overflow = 'auto'
    this.setState({ ...this.getReset(), [id]: false })
    history.pushState({}, '', window.location.pathname);
  }
}

export const modalContainer = new ModalContainer()
export const ModalSubscriber = ({ children }) => (
  <Provider>
    <Subscribe to={[modalContainer]}>
      { children }
    </Subscribe>
  </Provider>
)